// Auto-extracted from uploaded files. Kept original logic.
export function calculateAngle(coord1, coord2) {
                const dx = coord2[0] - coord1[0];
                const dy = coord2[1] - coord1[1];
                return Math.atan2(dy, dx);
            }
